module.exports = __webpack_public_path__ + "static/media/IMG_2403.58e09a13.jpg";